import { AccountDetails } from 'clientServerShared/types/account';
import { AppProviders } from 'projects/legacyClient/src/appProviders';
import { BreedSummaryCard } from '@embark/shared-components/src/breedSummary/breedSummaryCard';
import { BreedSummaryCardFragment } from '@embark/shared-components/src/generated/graphql-client-types';
import { FC } from 'react';
import { HeapCategory } from 'clientServerShared/types/eventTracking';
import ReactDOM from 'react-dom';
import { useAppSelector } from 'projects/legacyClient/src/react/state/hooks';

export function initPublicProfileBreedSummaryCard(): void {
  ReactDOM.render(
    <AppProviders>
      <PublicProfileBreedSummaryCardContainer />
    </AppProviders>,
    document.getElementById('public-profile-breed-summary-card')
  );
}

const PublicProfileBreedSummaryCardContainer: FC = () => {
  const data: BreedSummaryCardFragment = window['reactPet'];

  const accountDetails: AccountDetails | undefined = useAppSelector((state) => state.accountDetails);

  return (
    <BreedSummaryCard
      accountDetails={accountDetails}
      dog={data}
      showShare={false}
      showProductType={false}
      showCareResourcesBanner={false}
      heapMetadata={{ heapCategory: HeapCategory.RESULTS_BREED }}
    />
  );
};
